import { useEffect, useRef, useState } from "react";
import "./styles.css";

interface Props {
    value: string | undefined;
    onChange: (val: string | undefined) => void;
    placeholder?: string;
}

export default function FilterSearchInput({ value, onChange, placeholder }: Props) {
    const [local, setLocal] = useState(value ?? "");
    const timer = useRef<ReturnType<typeof setTimeout>>(undefined);

    useEffect(() => {
        setLocal(value ?? "");
    }, [value]);

    useEffect(() => () => clearTimeout(timer.current), []);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const val = e.target.value;
        setLocal(val);
        clearTimeout(timer.current);
        timer.current = setTimeout(() => onChange(val || undefined), 300);
    };

    return (
        <div className="filter-search-wrap">
            <img src="/icons/search-icon.svg" alt="" width={14} height={14} className="filter-search-icon" />
            <input className="filter-search-input" value={local} onChange={handleChange} placeholder={placeholder} type="search" />
        </div>
    );
}
